import { IProductoPortabilidad } from "./ProductosPortabilidad";

export interface IRequestPortabilidad {
    nombres?: string;
    apellidos?: string;
    rut?: string;
    telefono?: string;
    correo?: string;
    direccion?: string;
    comuna?: string;
    region?: string;
    nombreProveedorInicial?: string;
    rutProveedorInicial?: string;
    nombreProveedorNuevoReceptor?: string;
    rutProveedorNuevoReceptor?: string;
    productosContratar?: string[];
    productosValores?: IProductoPortabilidad[];
}

export class RequestPortabilidad implements IRequestPortabilidad {
    constructor(
        public nombres?: string,
        public apellidos?: string,
        public rut?: string,
        public telefono?: string,
        public correo?: string,
        public direccion?: string,
        public comuna?: string,
        public region?: string,
        public nombreProveedorInicial?: string,
        public rutProveedorInicial?: string,
        public nombreProveedorNuevoReceptor?: string,
        public rutProveedorNuevoReceptor?: string,
        public productosContratar?: string[],
        public productosValores?: IProductoPortabilidad[]
    ) {}
}